import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { Period, Tax, TaxBase, TaxItem, TaxType } from '../state/types'

export const useTaxBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildTax = (data: Data2) => {
        const {
            id = newId(),
            code,
            legalCode,
            name,
            type,
            taxBase,
            nonTaxableMin,
            nonTaxableMinPeriod,
            _yield,
            archived,
            system
        } = data
        const tax: Tax = {
            companyId: companyId!,
            id: id! as string,
            code: code! as string,
            legalCode: legalCode as string | undefined,
            name: name! as string,
            type: type! as TaxType,
            taxBase: taxBase! as TaxBase,
            nonTaxableMin: nonTaxableMin! as number,
            nonTaxableMinPeriod: nonTaxableMinPeriod as O<Period>,
            yield: _yield! as number,
            archived: !!archived,
            system: system as boolean | undefined
        }

        return tax
    }

    const buildTaxItem = (data: Data2) => {
        const { taxCode, taxYield, amount } = data
        const taxItem: TaxItem = {
            taxCode: taxCode! as string,
            taxYield: taxYield! as number,
            amount: amount! as number
        }

        return taxItem
    }

    return {
        buildTax,
        buildTaxItem
    }
}
